(function() {
  'use strict';

  angular.module('app').controller('FeedbackController', FeedbackController);

  FeedbackController.$inject = [
    '$rootScope', '$scope', '$routeParams', '$location', '$filter', '$timeout', 'blockUI',
    'NewsService', 'CouponsService', 'LANGS', 'SelectService', 'SettingsService', 'FeedbackService', 'NotifyService'];

  function FeedbackController($rootScope, $scope, $routeParams, $location, $filter, $timeout, blockUI,
      NewsService, CouponsService, LANGS, SelectService, SettingsService, FeedbackService, NotifyService) {

    $scope.isPageMode = isPageMode;
    // var block_feedback_sources = blockUI.instances.get('feedback_sources');

    $scope.model = {};
    $scope.model.feedbackLoyaltySettings = {};

    $scope.getFiltersList = SelectService.getLList;

    $scope.multilangInvitationText = MultilanguageHelper();
    $scope.multilangWelcomeMessage = MultilanguageHelper();
    $scope.multilangChatbotInvitationMessage = MultilanguageHelper();

    $scope.initLocaleStrings = initLocaleStrings;

    $scope.data = {
      mobile_app_feedback_allowed: [
        {value: 'none', title: 'none'},
        {value: 'authorized-users-only', title: 'authorized-users-only'},
        {value: 'all-users', title: 'all-users'}
      ],
      transaction_feedback_message_type: [
        {value: 'push-chatbot-sms', title: 'TEXT_PUSH_CHATBOT_VIBER_SMS'},
        {value: 'push-chatbot-viber', title: 'TEXT_PUSH_CHATBOT_VIBER'},
        {value: 'push-chatbot', title: 'TEXT_PUSH_CHATBOT'},
        {value: 'viber-sms', title: 'TEXT_VIBER_SMS'},
        {value: 'push', title: 'TEXT_PUSH'},
        {value: 'chatbot', title: 'TEXT_CHATBOT'},
        // {value: 'viber', title: 'TEXT_VIBER'},
        {value: 'sms', title: 'TEXT_SMS'},
        {value: 'email', title: 'TEXT_EMAIL'},
        {value: 'external-system', title: 'TEXT_EXTERNAL_SYSTEM'}
      ]
    };
    $scope.isLimitFeedback = false;

    var block_feedback_settings = blockUI.instances.get('feedbackSources_edit');

    $scope.platformSupportedLanguagesCodes = Object.keys(LANGS) || [];
    SettingsService.GetPlatformSupportedLanguages(function(success, response) {
      $scope.platformSupportedLanguagesCodes = response;
    });

    initController();

    function isPageMode(mode) {
      return mode == $scope._pageMode;
    }

    function isRouteMode(mode) {
      return $routeParams && $routeParams.hasOwnProperty('mode') && $routeParams.mode === mode;
    }

    function initPageMode() {
      $scope._pageMode = 'show';

      if (isRouteMode('edit')) {
        $scope._pageMode = ($routeParams.hasOwnProperty('terminal_id')) ? 'edit' : 'show';
      } else if (isRouteMode('create')) {
        $scope._pageMode = 'create';
      }

      switch ($scope._pageMode) {
        case 'show':
          _doShow();
          break;
        case 'create':
          //_doCreate();
          break;
        case 'edit':
          //_doEdit();
          break;
      }
    }

    function initController() {
      $scope.multilangInvitationText.initLangs(LANGS, $rootScope.LANG);
      $scope.multilangWelcomeMessage.initLangs(LANGS, $rootScope.LANG);
      $scope.multilangChatbotInvitationMessage.initLangs(LANGS, $rootScope.LANG);
      initPageMode();
    }

    /**
     * Init loyalty string
     */
    function initLocaleStrings(multiLanguageObj) {
      $scope.multilangInvitationText.initStrings(multiLanguageObj, ['mobile_app_feedback_invitation_text']);
      $scope.multilangWelcomeMessage.initStrings(multiLanguageObj, ['transaction_feedback_message_text']);
      $scope.multilangChatbotInvitationMessage.initStrings(multiLanguageObj, ['chatbot_feedback_invitation_text']);
    }

    /**
     * Event receive when change editing language
     */
    $scope.onChangeInvitationTextLanguage = function(new_lang) {
      $scope.multilangInvitationText.selected(new_lang);
    };
    $scope.onChangeWelcomeMessageLanguage = function(new_lang) {
      $scope.multilangWelcomeMessage.selected(new_lang);
    };
    $scope.onChangeChatbotInvitationMessageLanguage = function(new_lang) {
      $scope.multilangChatbotInvitationMessage.selected(new_lang);
    };

    function _doShow() {
    }

    function getLoyaltyFeedbackSettings(loyaltyId) {
      block_feedback_settings.start();
      FeedbackService.getFeedbackSettings(loyaltyId, function(success, data) {
        if (success) {
          $scope.model.feedbackLoyaltySettings = data;
          $scope.isLimitFeedback = !!$scope.model.feedbackLoyaltySettings.feedback_per_customer_limit;
          $scope.initLocaleStrings($scope.model.feedbackLoyaltySettings);
          getFeedbackSources($scope.data.currentFilter.id);
        } else {
          block_feedback_settings.stop();
        }
      });
    }

    $scope.saveLoyaltyFeedbackSettings = function(form) {
      if (isFormValid(form)) {
        if ($scope.data.feedbackSourcesList && !$scope.data.feedbackSourcesList.length) {
          return;
        }

        var modifyFeedbackSettingsParams = angular.copy($scope.model.feedbackLoyaltySettings);
        if (modifyFeedbackSettingsParams.transactionFeedbackSource) {
          modifyFeedbackSettingsParams.transaction_feedback_source_id = modifyFeedbackSettingsParams.transactionFeedbackSource.id;
          delete modifyFeedbackSettingsParams.transactionFeedbackSource;
        }
        if (modifyFeedbackSettingsParams.mobileAppFeedbackSource) {
          modifyFeedbackSettingsParams.mobile_app_feedback_source_id = modifyFeedbackSettingsParams.mobileAppFeedbackSource.id;
          delete modifyFeedbackSettingsParams.mobileAppFeedbackSource;
        }
        modifyFeedbackSettingsParams.feedback_source_id = modifyFeedbackSettingsParams.feedbackSource.id;
        delete modifyFeedbackSettingsParams.feedbackSource;

        FeedbackService.modifyLoyaltyCustomerFeedbackSettings($scope.data.currentFilter.id, modifyFeedbackSettingsParams,
            function(success, data) {
              if (success) {
                NotifyService.Success('Success', true);
              } else {
                NotifyService.Error('Error', true);
              }
            });
      }
    };

    function getFeedbackSources(loyaltyId) {
      FeedbackService.getFeedbackSources(loyaltyId, {
        page: 1,
        count: 20,
        only_active: false
      }, function(success, response) {
        if (success) {
          $scope.data.feedbackSourcesList = response.data;
          var settings = $scope.model.feedbackLoyaltySettings;
          $scope.data.feedbackSourcesList.forEach(function(source) {
            settings.transactionFeedbackSource = source.id === settings.transaction_feedback_source_id
                ? source
                : settings.transactionFeedbackSource;
            settings.mobileAppFeedbackSource = source.id === settings.mobile_app_feedback_source_id
                ? source
                : settings.mobileAppFeedbackSource;
            settings.feedbackSource = source.id === settings.feedback_source_id ? source : settings.feedbackSource;
          });
        }
        block_feedback_settings.stop();
      });
    }

    function setDefaultLanguage(country) {
      var lang = $rootScope.LANG;
      if (country)
        if (country === 'UA')
          return 'uk';
        else if (country === 'RU')
          return 'ru';
        else if (country === 'PL')
          return 'pl';
        else if (lang === 'ru')
          return 'ru';
        else
          return 'en';
      else
        return 'en';
    }

    $rootScope.$watch('L_LIST', function(newValue, oldValue) {
      if (newValue && newValue.length > 0) {
        $scope.data.filtersList = angular.copy($rootScope.L_LIST);

        if ($rootScope.ENV.filters.feedback_source && $rootScope.ENV.filters.feedback_source.filter &&
            $rootScope.ENV.filters.feedback_source.filter.id !== '0') {
          $scope.data.currentFilter = $rootScope.ENV.filters.feedback_source.filter;
        } else {
          for (var i in $scope.data.filtersList)
            if ($scope.data.filtersList[i].id === '0') {
              $scope.data.currentFilter = $scope.data.filtersList[i];
            } else {
              $scope.data.currentFilter = getFirstActive($scope.data.filtersList);
            }
        }
      }
    });

    $scope.$watch('data.currentFilter', function(newValue, oldValue) {
      console.log('Old value', oldValue, 'New value =>', newValue);
      if (newValue) {
        var l = $rootScope.ENV.filters.feedback_source;
        if (l)
          l.filter = newValue;
        else
          l = {filter: newValue};

        $rootScope.ENV.filters.feedback_source = l;
        $rootScope.storeENV();

        console.log('data => ', l.filter.id);
        getLoyaltyFeedbackSettings(l.filter.id);

        _doShow();
      }
    }, true);

    $scope.onChangeLimitFeedback = function() {
      $scope.isLimitFeedback = !$scope.isLimitFeedback;
      if ($scope.isLimitFeedback) {
        $scope.model.feedbackLoyaltySettings.feedback_per_customer_limit = 1;
      } else {
        $scope.model.feedbackLoyaltySettings.feedback_per_customer_limit = 0;
      }
    };

    $scope.hasActiveSource = function() {
      if ($scope.data.feedbackSourcesList && $scope.data.feedbackSourcesList.length) {
        return $scope.data.feedbackSourcesList.some(function(source) {
          return !!source.active;
        });
      } else {
        return true;
      }
    };
  }
})();
